import { ActionReducer } from '@ngrx/store';
import { ErrorAction, errorAdd, errorRemove } from '../../../core/reducers/loading-error.reducer';
import * as consentActions from '../actions/consent.actions';
import * as enableActions from '../actions/enable-consent.actions';
import * as disableActions from '../actions/disable-consent.actions';

type Actions = consentActions.Actions | enableActions.Actions | disableActions.Actions;

/**
 * Loading error reducer manages errors during server communication.
 */
export const loadingError: ActionReducer<any> = (state: any = {}, action: Actions) => {

    switch (action.type) {
        case consentActions.LOAD_ERROR:
            return errorAdd(state, new ErrorAction(consentActions.LOAD_ERROR, action.payload));
        case consentActions.LOAD_SUCCESS:
            return errorRemove(state, new ErrorAction(consentActions.LOAD_ERROR));

        // first initial update request; authorization iframe follows
        case enableActions.ENABLE_CONSENT_ERROR:
            return errorAdd(state, new ErrorAction(enableActions.ENABLE_CONSENT_ERROR, action.payload));
        case enableActions.ENABLE_CONSENT_SUCCESS:
            return errorRemove(state, new ErrorAction(enableActions.ENABLE_CONSENT_ERROR));


        // disable consent
        case disableActions.DISABLE_CONSENT_ERROR:
            return errorAdd(state, new ErrorAction(disableActions.DISABLE_CONSENT_ERROR, action.payload));
        case disableActions.DISABLE_CONSENT_SUCCESS:
            return errorRemove(state, new ErrorAction(disableActions.DISABLE_CONSENT_ERROR));

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/consent/reducers/loading-error.reducer.ts